import styled from 'styled-components';

export const OpportunityBadgeWrapper = styled.div`
  display: flex;
  padding: 4px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  border-radius: 8px 8px 0px 0px;
  background-color: ${({ theme }) => theme.palette.NL800};
  height: 26px;
  cursor: pointer;
`;
export const EventsBadgeWrapper = styled.div`
  display: flex;
  padding: 4px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  border-radius: 8px 8px 0px 0px;
  background-color: ${({ theme }) => theme.palette.O500};
  height: 26px;
`;
export const EventsRowDesktop = styled.div`
  display: flex;
  padding-right: 10px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
`;
